import * as React from 'react';
import PartnerDialog from '../Search/SearchResults/PartnerResult/PartnerDialog';

interface ICoordinatorsProps {
    coordinators: any[];
}

const Coordinators: React.FC<ICoordinatorsProps> = ({coordinators}) => {
    const handlePartnerClick = (partnerId: string) => {
        const url = `/organization/${partnerId}`;
        window.open(url, '_blank');
    };

    return (
        <div className='coordinator-data-parent org-container'>
            <span style={{color: 'red', fontWeight: 'bold', width: "100%", fontSize: "16px"}}>Collaboration ({coordinators?.length || 0})</span>
            <div className='coordinator-data'>
            {coordinators ? coordinators.sort((a, b) => (b?.numberOfProjects || 0) - (a?.numberOfProjects || 0)).map((coordinator, index) => (
                <button key={index} className='coordinator-container' onClick={() => {handlePartnerClick(coordinator?.pic)}}>
                    <span>Legal Name: <b style={{fontSize: "14px"}}>{coordinator?.legalName}</b></span>
                    <span>Business Name: {coordinator?.businessName}</span>
                    <span>Classification Type: {coordinator?.classificationType}</span>
                    <span>Number Of Projects: {coordinator?.numberOfProjects}</span>
                </button>
            )) : <span style={{marginLeft: "45%", marginTop: "20%"}}>No data available</span>}
            </div>
            <PartnerDialog />
        </div>
    );
};

export const CoordinatorData = React.memo(Coordinators);